import type { JSX } from 'react';

import { KUNDENMARKENWORT, type Kundenmarke as Marke } from '../api/kunden';
import { markenklasse, type Markenart } from '../marken';

/**
 * Die Kennzeichnung ordnet ein und bewertet nicht (2.10).
 *
 * „Kunde" trug früher dieselbe grüne Fläche wie ein bezahlter Beleg. Ein Kunde
 * ist aber kein erreichtes Ziel, sondern der Normalfall der Liste. Der
 * INTERESSENT bleibt in Achtung: An ihm ist etwas zu tun. Der KOSTENTRÄGER
 * (PRD-38, CRM-171) ist es nicht — er bucht nie und wird nie Kunde; er steht
 * neutral wie der Kunde.
 */
const MARKENART: Readonly<Record<Marke, Markenart>> = {
  kunde: 'laufend',
  interessent: 'aufmerksamkeit',
  kostentraeger: 'laufend',
  inaktiv: 'stillgelegt',
};

/**
 * Eine Kennzeichnung für Liste und Akte — an einer Stelle, damit beide gleich
 * sprechen. Mit `art` steht die Art des Kostenträgers dahinter
 * („Kostenträger · Berufsgenossenschaft"). WCAG 1.4.1: Der Zustand steht als
 * Text da, nicht als Farbe.
 */
export function Kundenmarke({
  marke,
  art,
}: {
  readonly marke: Marke;
  readonly art?: string | undefined;
}): JSX.Element {
  const wort = KUNDENMARKENWORT[marke];
  return (
    <span className={markenklasse(MARKENART[marke])}>
      {marke === 'kostentraeger' && art !== undefined ? `${wort} · ${art}` : wort}
    </span>
  );
}
